import React from "react";
import { FaPhone, FaWhatsapp, FaMapMarkerAlt } from "react-icons/fa";

const formatPhoneNumber = (number) => {
  if (!number) return "";

  const digits = number.replace(/\D/g, "");

  if (digits.length === 10) {
    return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
  }

  return number;
};

const formatWhatsAppNumber = (number) => {
  if (!number) return "";

  const digits = number.replace(/\D/g, "");

  // Convert South African number from 0XXXXXXXXX
  // to international format 27XXXXXXXXX
  if (digits.startsWith("0") && digits.length === 10) {
    return `27${digits.slice(1)}`;
  }

  return digits;
};

const WantProductCard = ({ product, onClick }) => {
  const isActive = product.is_active;

  return (
    <div
      onClick={onClick}
      className={`relative bg-white rounded-lg border border-gray-300 shadow-sm hover:shadow-md transition w-full overflow-hidden cursor-pointer ${
        !isActive ? "opacity-75" : ""
      }`}
    >

      {/* HEADER */}
      <div className="px-5 py-4 bg-gray-50 border-b border-gray-200">

        <div className="flex items-start justify-between gap-4">

          {/* NAME */}
          <p className="text-lg sm:text-xl font-semibold text-gray-800 leading-tight">
            {product.name}
          </p>

          {/* WANTED BADGE */}
          {isActive && (
            <span className="flex-shrink-0 px-3 py-1 rounded-full bg-blue-700 text-white text-xs font-bold tracking-wide">
              WANTED
            </span>
          )}

        </div>

      </div>

      {/* CONTENT */}
      <div className="px-5 py-5">

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

          {/* LEFT - DESCRIPTION */}
          <div className="md:col-span-2">

            {product.description && (
              <div>
                <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">
                  Description
                </p>

                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                  {product.description}
                </p>
              </div>
            )}

          </div>

          {/* RIGHT - DETAILS */}
          <div className="flex flex-col gap-3">

            {/* BUDGET */}
            {product.budget && (
              <div>
                <p className="text-xs text-gray-500 uppercase tracking-wide">
                  Budget
                </p>

                <p
                  className={`font-bold text-lg ${
                    isActive
                      ? "text-green-800"
                      : "text-gray-500"
                  }`}
                >
                  R{Number(product.budget).toLocaleString("en-ZA", {
                    maximumFractionDigits: 0,
                  })}
                </p>
              </div>
            )}

            {/* LOCATION */}
            {product.location && (
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <FaMapMarkerAlt className="text-green-700 flex-shrink-0" />

                <span>{product.location}</span>
              </div>
            )}

          </div>

        </div>

        {/* CONTACT DETAILS */}
        {(product.contact_phone || product.contact_whatsapp) && (
          <div className="border-t border-gray-200 pt-4 mt-5">

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">

              {/* PHONE */}
              {product.contact_phone && (
                <div className="flex items-center gap-2 text-sm text-gray-700">
                  <FaPhone className="text-green-800 flex-shrink-0" />

                  <span>
                    {formatPhoneNumber(product.contact_phone)}
                  </span>
                </div>
              )}

              {/* WHATSAPP */}
              {product.contact_whatsapp && (
                <a
                  href={`https://wa.me/${formatWhatsAppNumber(
                    product.contact_whatsapp
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                  className="flex items-center gap-2 text-sm text-gray-700 hover:text-green-800 transition"
                >
                  <FaWhatsapp className="text-green-700 flex-shrink-0" />

                  <span>
                    {formatPhoneNumber(product.contact_whatsapp)}
                  </span>
                </a>
              )}

            </div>

          </div>
        )}

      </div>

      {/* FULFILLED DIAGONAL RIBBON */}
      {!isActive && (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">

          <div className="w-[120%] -rotate-12 bg-green-600/95 text-white text-center py-3 shadow-lg">

            <span className="text-base sm:text-lg font-extrabold tracking-[0.2em]">
              FULFILLED
            </span>

          </div>

        </div>
      )}

    </div>
  );
};

export default WantProductCard;